import { useCostRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetCostCommonInfoQuery } from "../../features/api/costApi";

export { useCostRoutes };

export default GetDefaultIndex({
  title: "بهای تمام شده",
  query: useGetCostCommonInfoQuery,
});
